<template>
  <div id="app">
    <div class="container">
      <VueSignaturePad
        height="300px"
        :customStyle="{ border: '#707070 1px solid', borderRadius: '8px' }"
        ref="signaturePad"
        :options="{ minWidth: 5, maxWidth: 5, dotSize: 5 }"
      />
    </div>
    <div class="row col-12 justify-between q-mt-sm">
      <div>
        <q-btn
          @click="undo"
          color="negative"
          icon="delete"
          no-caps
          flat
          rounded
        />
      </div>
      <div>
        <q-btn
          @click="save()"
          color="positive"
          icon="done"
          no-caps
          flat
          rounded
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update", "assinar"],
  props: ["restart", "go"],
  name: "MySignaturePad",

  methods: {
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);

      this.$emit("update", data);
      this.$emit("assinar");
    },
  },
  watch: {
    restart() {
      this.undo();
    },
    go() {
      this.save();
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid #707070;
  background-color: white;
  cursor: crosshair;
  border-radius: 10px;
}

.buttonsCanvas {
  margin-top: 100px;
}

.save {
  margin-left: 10px;
}
.container {
  position: relative;
}
</style>
